import { render, staticRenderFns } from "./PageSecondary.vue?vue&type=template&id=7a3c487c&scoped=true"
import script from "./PageSecondary.vue?vue&type=script&lang=js"
export * from "./PageSecondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3c487c",
  null
  
)

export default component.exports